import { useContext, useEffect } from 'react';

import { LocationContext } from 'state/location';
import { MParticleContext } from 'state/mParticle';

export default function useLogPageView() {
  const locationContext = useContext(LocationContext);
  const { pathname } = locationContext.location;
  const mParticle = useContext(MParticleContext);

  useEffect(() => {
    mParticle.logPageView(pathname, { pathname });
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
